import React, { PureComponent } from "react"
import Media from "react-media"
import Slider from "react-slick"
import { AdminContextConsumer } from "@components/ui-builder/index"
import { GalleryCollection, GalleryDragSource, TeaserEdit } from "@components/content-feed/admin"
import { TeaserGalleryItem } from "./Teaser"

class Gallery extends PureComponent {
  constructor(props) {
    super(props)
    // hack for server side rendering
    // (media queries)
    this.state = { isClient: false }
  }
  componentDidMount() {
    this.setState({ isClient: true })
  }
  render() {
    const { items, item: galleryItem, isNew, showRemove, showEdit } = this.props
    if (items.length === 0) {
      return null
    }
    return (
      <AdminContextConsumer>
        {isAdmin => (
          <Media
            query="(min-width: 769px)"
            ref={comp => (this.mediaComponent = comp)}
          >
            {matches =>
              matches && this.state.isClient && !isAdmin ? (
                <Slider
                  key={`content-feed-gallery-slider`}
                  slidesToShow={1}
                  variableWidth={true}
                  className="content-feed-gallery"
                >
                  {items.map(item => (
                    <div key={item.id}>
                      <TeaserGalleryItem {...item} />
                    </div>
                  ))}
                </Slider>
              ) : (
                <GalleryCollection
                  className="content-feed-gallery-native"
                  galleryItem={galleryItem}
                  data={items}
                  defaultRender={() => (
                    <div className="content-feed-gallery-native">
                      {items.map(item => (
                        <TeaserGalleryItem {...item} key={item.id} />
                      ))}
                    </div>
                  )}
                  renderItem={item => (
                    <GalleryDragSource key={item.id} item={item} isNew={isNew}>
                      <TeaserEdit
                        showRemove={showRemove}
                        showEdit={showEdit}
                        asGallery
                        galleryItem={galleryItem}
                        item={item}
                        isNew={isNew}
                      >
                        <TeaserGalleryItem {...item} key={item.id} />
                      </TeaserEdit>
                    </GalleryDragSource>
                  )}
                />
              )
            }
          </Media>
        )}
      </AdminContextConsumer>
    )
  }
}

export default Gallery
